export const GTM_CONTAINER_ID = 'GTM-W2JXKP2N';
export const CONSENT_STORAGE_KEY = 'webcredai-consent-v1';

const CONSENT_GRANTED = 'granted';
const CONSENT_DENIED = 'denied';
const CONSENT_PENDING = 'pending';

const BASE_CONSENT = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
  functionality_storage: 'granted',
  personalization_storage: 'denied',
  security_storage: 'granted',
};

function getDataLayer() {
  if (typeof window === 'undefined') return null;
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}

function getGtag() {
  if (typeof window === 'undefined') return null;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
  return window.gtag;
}

export function getStoredConsentChoice() {
  if (typeof window === 'undefined') return CONSENT_PENDING;
  const stored = window.localStorage.getItem(CONSENT_STORAGE_KEY);
  if (stored === CONSENT_GRANTED || stored === CONSENT_DENIED) {
    return stored;
  }
  return CONSENT_PENDING;
}

function consentPayloadFor(choice) {
  return {
    ...BASE_CONSENT,
    analytics_storage: choice === CONSENT_GRANTED ? CONSENT_GRANTED : CONSENT_DENIED,
  };
}

export function applyConsentChoice(choice, { persist = true } = {}) {
  if (typeof window === 'undefined') return CONSENT_PENDING;
  const normalizedChoice = choice === CONSENT_GRANTED ? CONSENT_GRANTED : CONSENT_DENIED;
  if (persist) {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, normalizedChoice);
  }
  window.__webcredaiConsentState = normalizedChoice;
  const gtag = getGtag();
  if (gtag) {
    gtag('consent', 'update', consentPayloadFor(normalizedChoice));
  }
  pushDataLayerEvent('webcredai_consent_updated', {
    analytics_consent: normalizedChoice,
  });
  return normalizedChoice;
}

export function pushDataLayerEvent(eventName, payload = {}) {
  if (!eventName) return;
  const dataLayer = getDataLayer();
  if (!dataLayer) return;
  dataLayer.push({
    event: eventName,
    ...payload,
  });
}

export function trackPageView({ pagePath, pageLocation, pageTitle }) {
  pushDataLayerEvent('webcredai_page_view', {
    page_path: pagePath,
    page_location: pageLocation,
    page_title: pageTitle,
  });
}
